export enum DrivingLicenceType {
  Automatic = "Automatic",
  Manual = "Manual",
}
